import React, { Fragment } from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { Form, Switch } from 'antd';
import FormLabel from 'components/FormLabel/FormLabel';

const FormItem = Form.Item;

const FormToggleDescription = styled(FormLabel)`
  margin-bottom: 0px;
`

const addRules = requiredErrorMessage => {
  const rules = [];
  if (requiredErrorMessage && typeof requiredErrorMessage === 'string') {
    rules.push({
      required: true,
      message: requiredErrorMessage
    });
  }
  return rules;
};

const FormToggle = ({ className, defaultValue, form, formLabel, label, onChange, name, requiredErrorMessage, size, shouldDisabled }) => {
  const rules = addRules(requiredErrorMessage);
  return (
    <Fragment>
      {!formLabel && (
        <FormToggleDescription size={size}>
          {label || name}
        </FormToggleDescription>
      )}
      <FormItem label={formLabel} colon={false}>
        {form.getFieldDecorator(name, {
          rules: rules,
          initialValue: defaultValue
        })(
          <div>
            <Switch checkedChildren="Yes" unCheckedChildren="No" size={size} onChange={onChange} defaultChecked disabled={shouldDisabled} />
          </div>
        )}
      </FormItem>
    </Fragment>
  );
};

FormToggle.propTypes = {
  form: PropTypes.object.isRequired,
  formLabel: PropTypes.string,
  name: PropTypes.string,
  defaultValue: PropTypes.any,
  label: PropTypes.string,
  onChange: PropTypes.func,
  requiredErrorMessage: PropTypes.string,
  shouldDisable: PropTypes.bool,
  size: PropTypes.oneOf(['default', 'large'])
};

FormToggle.defaultProps = {
  form: {},
  label: '',
  placeholder: '',
  shouldDisable: false,
  requiredErrorMessage: '',
  size: 'default'
};

export default FormToggle;
